inputs-search-select-phase
  div(class="form-group row { error: opts.errors }")
    input(type="hidden" value="{ opts.value }" name="{ opts.name }" )
    label.col-md-2.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-10
      span.phase-wrap(each="{opts.items}" style="border-bottom:5px solid {colorcode}")
        .checkbox-fade.fade-in-primary
          label
            input(type="checkbox" value="{ value }" onClick="{ this.onChange }" checked="{checked}")
            span.cr
              i.cr-icon.icofont.icofont-ui-check.txt-primary
            span { label }
  script(type="typescript").
    this.mixin('inputs.search.select-phase');
  style(scoped).
    .phase-wrap {
      display: inline-block;
      margin-right: 1px;
      border-radius: 2px;
      padding: 7px 10px 0px 0;
      margin-bottom: .5rem;
    }
    .phase-wrap label {
      margin-bottom: 0;
    }
    .checkbox-fade .cr {
      margin-right: .5rem;
    }
    .checkbox-fade {
      margin-right: .5rem;
    }
